module.exports = __webpack_public_path__ + "img/zhuanpan.1df5cd5e.png";